export default {
    meta: {
        title: '未签约保护点位列表',
        url: '/fishtogether/beforecontract',
        urlName: '签约前申请保护'
    }
};
